import { Avatar, Chip, Listbox, ListboxItem } from "@heroui/react";

function RankList({ list, onRoomChange, currentRoom }) {
	console.log(list);
	return (
		<Listbox>
			{list.map((item, index) => {
				const isSelected =
					Boolean(currentRoom) &&
					Boolean(item.LiveRoom) &&
					String(currentRoom) === String(item.LiveRoom);

				return (
					<ListboxItem
						key={item.LiveRoom || item.LiverID || item.uid || index}
						onClick={() => {
							if (!item.LiveRoom) return;
							if (isSelected) {
								onRoomChange("");
							} else {
								onRoomChange(String(item.LiveRoom));
							}
						}}
						className={`group relative overflow-hidden rounded-xl px-2.5 pt-2 pb-2.5 transition-all duration-150 select-none ${
							!item.LiveRoom ? "cursor-default" : "cursor-pointer"
						} ${
							isSelected
								? "bg-primary-50/80 dark:bg-primary-950/40 ring-1.5 ring-primary"
								: "hover:bg-default-100 dark:hover:bg-default-50/40"
						}`}
					>
						{/* 内容区：左右两端对齐，列内元素各自保持精准列对齐 */}
						<div className="relative z-10 flex items-center justify-between gap-2">
							{/* 左侧：排名序号 + 头像 + 主播名 */}
							<div className="flex items-center gap-2.5 min-w-0 flex-1">
								<span
									className={`w-5 text-center text-xs font-bold tabular-nums shrink-0 ${
										index === 0
											? "text-warning font-black text-sm"
											: index === 1
												? "text-primary font-bold"
												: index === 2
													? "text-success font-bold"
													: "text-default-500 font-medium"
									}`}
								>
									{index + 1}
								</span>
								<Avatar
									src={`${AVATAR_API}${item.LiverID}`}
									size="sm"
									className={`w-7 h-7 shrink-0 transition-transform group-hover:scale-105 ${
										index === 0
											? "ring-1.5 ring-warning/60"
											: index === 1
												? "ring-1.5 ring-primary/50"
												: index === 2
													? "ring-1.5 ring-success/50"
													: "ring-1 ring-default-200/80 dark:ring-default-100/20"
									}`}
								/>
								<span
									className={`text-[14px] truncate transition-colors ${
										isSelected
											? "text-primary font-bold"
											: "font-semibold"
									}`}
								>
									{item.Liver}
								</span>
							</div>

							{/* 右侧：数量列右对齐 + 胶囊固定宽度 */}
							<div className="flex items-center gap-2.5 shrink-0">
								<span className="w-[68x] text-right text-[13px] tabular-nums font-bold">
									{item.CountNode}
								</span>
								<Chip
									size="sm"
									variant="flat"
									color={
										isSelected
											? "primary"
											: index === 0
												? "warning"
												: index === 1
													? "primary"
													: index === 2
														? "success"
														: "default"
									}
									className="h-7 w-[86px] px-2 border-0 shrink-0 font-bold"
								>
									<div className="flex items-center justify-between w-full gap-1.5">
										<div className="w-7 h-1.5 rounded-full bg-current/25 overflow-hidden shrink-0">
											<div
												className="h-full rounded-full bg-current transition-all duration-300"
												style={{
													width: `${Math.min(100, Math.max(0, (item.Rate ?? 0) * 100))}%`,
												}}
											/>
										</div>
										<span className="text-xs tabular-nums leading-none w-9 text-right shrink-0">
											{parseFloat(
												(
													(item.Rate ?? 0) * 100
												).toFixed(1),
											)}
											%
										</span>
									</div>
								</Chip>
							</div>
						</div>
					</ListboxItem>
				);
			})}
		</Listbox>
	);
}

export default RankList;
